// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import Header from "../components/header";
// import { apiurl } from "../config/config";
// import heic2any from "heic2any";
// import {
//   Upload,
//   CheckCircle,
//   XCircle,
//   User,
//   Mail,
//   Phone,
//   Briefcase,
//   Building2,
//   Calendar,
//   ShieldCheck,
// } from "lucide-react";

// const UploadDocumentsByToken = () => {
//   const { employeeToken } = useParams();
//   const navigate = useNavigate();

//   const [employeeDetails, setEmployeeDetails] = useState(null);
//   const employee = employeeDetails;
//   const [tokenState, setTokenState] = useState("loading"); 
//   // loading | valid | used | expired

//   const [documents, setDocuments] = useState({
//     aadharCardFront: { uploaded: false, link: null },
//     aadharCardBack: { uploaded: false, link: null }
//   });

//   const [uploadingKey, setUploadingKey] = useState("");

// useEffect(() => {
//   const fetchEmployee = async () => {
//     try {
//       const { data } = await axios.post(
//         `${apiurl}/api/employee/get-details/${employeeToken}`
//       );

//       if (data.expired) {
//         setTokenState("expired");
//         return;
//       }

//       if (data.used) {
//         setTokenState("used");
//         return;
//       }

//       setEmployeeDetails(data.employee);
//       setDocuments(data.employee.documents || documents);
//       setTokenState("valid");

//     } catch (err) {
//       setTokenState("expired");
//     }
//   };

//   fetchEmployee();
// }, [employeeToken]);

//   // Convert HEIC and Upload File
//   const handleAadharUpload = async (e, docKey) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     let finalFile = file;

//     if (file.type === "image/heic" || file.name.endsWith(".heic")) {
//       try {
//         const convertedBlob = await heic2any({ blob: file, toType: "image/jpeg" });
//         finalFile = new File([convertedBlob], file.name.replace(".heic", ".jpg"), {
//           type: "image/jpeg"
//         });
//       } catch (error) {
//         alert("HEIC conversion failed.");
//         return;
//       }
//     }

//     const formData = new FormData();
//     formData.append("file", finalFile);
//     formData.append(
//       "folder",
//       employeeDetails?.identification?.aadharNumber || "employee-documents"
//     );

//     setUploadingKey(docKey);

//     try {
//       const uploadRes = await axios.post(
//         `${apiurl}/api/media/employeeFileUpload`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" }, timeout: 60000 }
//       );

//       if (uploadRes.data.success) {
//         setDocuments((prev) => ({
//           ...prev,
//           [docKey]: { uploaded: true, link: uploadRes.data.fileUrl }
//         }));
//       }
//     } catch (err) {
//       alert("Upload failed.");
//     } finally {
//       setUploadingKey("");
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       const res = await axios.post(
//         `${apiurl}/api/employee/updateEmployeeDetailsByToken/${employeeToken}`,
//         { documents }
//       );

//       if (res.data.success) {
//         navigate(`/employees/thankyou/${employeeToken}`);
//       }
//     } catch (err) {
//       alert("Submit failed.");
//     }
//   };

//   // =============================
//   // TOKEN STATE SCREENS
//   // =============================

//   if (tokenState === "loading") {
//     return (
//       <div className="h-screen flex justify-center items-center text-gray-600">
//         Verifying your link...
//       </div>
//     );
//   }

//   if (tokenState === "expired") {
//     return (
//       <div className="h-screen flex flex-col justify-center items-center bg-red-50 text-red-700">
//         <h1 className="text-3xl font-bold">Link Expired</h1>
//         <p className="text-lg mt-2">Please contact HR to request a new link.</p>
//       </div>
//     );
//   }

//   if (tokenState === "used") {
//     return (
//       <div className="h-screen flex flex-col justify-center items-center bg-green-50 text-green-700">
//         <h1 className="text-3xl font-bold">Aadhaar Already Submitted</h1>
//         <p className="text-lg mt-2">Thank you! Your KYC is already complete.</p>
//       </div>
//     );
//   }

//   // =============================
//   // MAIN UPLOAD SCREEN (VALID TOKEN)
//   // =============================

//   return (
//     <>
//       {/* <Header title="Aadhar Card Upload" /> */}

//       <div className="max-w-xl mx-auto p-6 bg-white shadow-xl rounded-2xl mt-10 border border-gray-200">
//         <h2 className="text-2xl font-bold text-center mb-5">Upload Aadhaar Card</h2>

//         {/* EMPLOYEE DETAILS CARD */}
//         <div className="bg-blue-50 border border-blue-200 p-6 rounded-xl mb-6">
//           <h2 className="text-xl font-bold text-blue-900 mb-4">
//             Employee Details
//           </h2>

//           <div className="space-y-3 text-gray-700">
//             <div className="flex items-center gap-3">
//               <User className="w-5 h-5" />
//               <span className="font-semibold text-lg">
//                 {employee?.personalDetails?.firstName}{" "}
//                 {employee?.personalDetails?.lastName}
//               </span>
//             </div>

//             <div className="flex items-center gap-3">
//               <Mail className="w-5 h-5" />
//               <span>{employee?.personalDetails?.email}</span>
//             </div>

//             <div className="flex items-center gap-3">
//               <Phone className="w-5 h-5" />
//               <span>{employee?.personalDetails?.phone}</span>
//             </div>

//             <div className="flex items-center gap-3">
//               <ShieldCheck className="w-5 h-5" />
//               <span>Employee ID: {employee?.employeeId}</span>
//             </div>

//             <div className="flex items-center gap-3">
//               <Briefcase className="w-5 h-5" />
//               <span>Designation: {employee?.designation}</span>
//             </div>

//             <div className="flex items-center gap-3">
//               <Building2 className="w-5 h-5" />
//               <span>Department: {employee?.department}</span>
//             </div>

//             <div className="flex items-center gap-3">
//               <User className="w-5 h-5" />
//               <span>Manager: {employee?.reportingManagerName}</span>
//             </div>

//             <div className="flex items-center gap-3">
//               <Calendar className="w-5 h-5" />
//               <span>
//                 Joining Date:{" "}
//                 {new Date(employee?.employeeJoiningDate).toLocaleDateString()}
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Aadhaar Front */}
//         <div className="border p-4 rounded-xl mb-4">
//           <label className="font-semibold text-gray-700">Aadhar Card Front</label>

//           {documents.aadharCardFront.uploaded ? (
//             <div className="bg-green-100 p-2 mt-2 rounded flex justify-between items-center">
//               <a
//                 href={documents.aadharCardFront.link}
//                 className="text-sm underline"
//                 target="_blank"
//               >
//                 View Uploaded File
//               </a>
//               <button
//                 className="text-red-500 text-sm"
//                 onClick={() =>
//                   setDocuments((prev) => ({
//                     ...prev,
//                     aadharCardFront: { uploaded: false, link: null }
//                   }))
//                 }
//               >
//                 Remove
//               </button>
//             </div>
//           ) : (
//             <>
//               <input
//                 type="file"
//                 accept="image/jpeg,image/png,application/pdf"
//                 className="mt-2"
//                 onChange={(e) => handleAadharUpload(e, "aadharCardFront")}
//               />
//               {uploadingKey === "aadharCardFront" && (
//                 <p className="text-blue-600 mt-2">Uploading...</p>
//               )}
//             </>
//           )}
//         </div>

//         {/* Aadhaar Back */}
//         <div className="border p-4 rounded-xl mb-4">
//           <label className="font-semibold text-gray-700">Aadhar Card Back</label>

//           {documents.aadharCardBack.uploaded ? (
//             <div className="bg-green-100 p-2 mt-2 rounded flex justify-between items-center">
//               <a
//                 href={documents.aadharCardBack.link}
//                 className="text-sm underline"
//                 target="_blank"
//               >
//                 View Uploaded File
//               </a>
//               <button
//                 className="text-red-500 text-sm"
//                 onClick={() =>
//                   setDocuments((prev) => ({
//                     ...prev,
//                     aadharCardBack: { uploaded: false, link: null }
//                   }))
//                 }
//               >
//                 Remove
//               </button>
//             </div>
//           ) : (
//             <>
//               <input
//                 type="file"
//                 accept="image/jpeg,image/png,application/pdf"
//                 className="mt-2"
//                 onChange={(e) => handleAadharUpload(e, "aadharCardBack")}
//               />
//               {uploadingKey === "aadharCardBack" && (
//                 <p className="text-blue-600 mt-2">Uploading...</p>
//               )}
//             </>
//           )}
//         </div>

//         <button
//           onClick={handleSubmit}
//           disabled={
//             !documents.aadharCardFront.uploaded ||
//             !documents.aadharCardBack.uploaded
//           }
//           className={`mt-5 w-full py-3 rounded-lg text-white font-semibold ${
//             documents.aadharCardFront.uploaded &&
//             documents.aadharCardBack.uploaded
//               ? "bg-blue-600 hover:bg-blue-700"
//               : "bg-gray-400 cursor-not-allowed"
//           }`}
//         >
//           Submit Aadhaar Documents
//         </button>
//       </div>
//     </>
//   );
// };

// export default UploadDocumentsByToken;

import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import heic2any from "heic2any";
import { useParams, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  Upload,
  CheckCircle,
  XCircle,
  User,
  Mail,
  Phone,
  Briefcase,
  Building2,
  Calendar,
  ShieldCheck,
  FileText,
} from "lucide-react";
import { apiurl } from "../config/config";
import { toast } from "react-toastify";

/**
 * UploadDocumentsV3
 * - Dynamic documents (requiredDocs)
 * - Progress stepper for each document
 * - Animated cards + checkmark effects
 * - Lottie animations (celebration when 100%)
 * - HEIC conversion
 * - Upload to your existing /api/media/employeeFileUpload endpoint
 *
 * Paste this component into your codebase and import where needed.
 */

export default function UploadDocumentsV3() {
  const { employeeToken } = useParams();
  const navigate = useNavigate();

  const [employee, setEmployee] = useState(null);
  const [tokenState, setTokenState] = useState("loading"); // loading | valid | used | expired
  const [documents, setDocuments] = useState({}); // dynamic from server
  const [uploadingKey, setUploadingKey] = useState(null);
  const [completionPercent, setCompletionPercent] = useState(0);
  const [showCongrats, setShowCongrats] = useState(false);
  const [loading, setLoading] = useState(true);

  // Default required docs mapping (label + type)
  // The UI is dynamic: if your API returns requiredDocs you can replace this on fetch.
  const defaultRequiredDocs = {
    passportSizePhotos: { label: "Profile Photo", type: "image" },
    panCard: { label: "PAN Card", type: "image" },
    aadharCardFront: { label: "Aadhaar Card (Front)", type: "image" },
    aadharCardBack: { label: "Aadhaar Card (Back)", type: "image" },
    cancelledChequeOrPassbook: { label: "Cancelled Cheque / Passbook", type: "image" },
    bankStatement: { label: "Bank Statement", type: "pdf" },
  };

  const [requiredDocs, setRequiredDocs] = useState(defaultRequiredDocs);

  // Lottie URLs (you can swap with local JSONs)
  const lottieCelebrate = "https://assets10.lottiefiles.com/packages/lf20_jbrw3hcz.json";
  const lottieAlmost = "https://assets2.lottiefiles.com/packages/lf20_w51pcehl.json";

  // Fetch employee & document data on mount
  useEffect(() => {
async function fetchData() {
  setLoading(true);
  try {
    const res = await axios.post(`${apiurl}/api/employee/get-details/${employeeToken}`);
    const data = res.data;

    if (data.expired) {
      setTokenState("expired");
      return;
    }
    if (data.used) {
      setTokenState("used");
      return;
    }

    setEmployee(data.employee);

    // Convert employee's existing uploaded documents
const convertedDocs = {};
Object.keys(defaultRequiredDocs).forEach((key) => {
  const docObj = data.employee?.documents?.[key];

  if (docObj?.uploaded === true && docObj?.link) {
    convertedDocs[key] = {
      uploaded: true,
      link: docObj.link,
      verificationStatus: docObj.verificationStatus || "pending",
    };
  } else {
    convertedDocs[key] = {
      uploaded: false,
      link: null,
      verificationStatus: "pending",
    };
  }
});


    // Merge with backend documents
    setDocuments({
      ...convertedDocs,
      ...(data.documents || {}),
    });

    // Server-defined required docs (optional)
    if (data.requiredDocs) setRequiredDocs(data.requiredDocs);

    setTokenState("valid");
  } catch (err) {
    console.error(err);
    setTokenState("expired");
  } finally {
    setLoading(false);
  }
}

    fetchData();
  }, [employeeToken]);

  // Recalculate completion percent whenever documents or requiredDocs change
  useEffect(() => {
    const keys = Object.keys(requiredDocs);
    if (keys.length === 0) {
      setCompletionPercent(0);
      return;
    }
    let uploadedCount = 0;
    keys.forEach((k) => {
      if (documents[k]?.uploaded === true && documents[k]?.link) uploadedCount++;
    });
    const percent = Math.round((uploadedCount / keys.length) * 100);
    setCompletionPercent(percent);
    if (percent === 100) {
      setShowCongrats(true);
      // auto-hide after some seconds
      setTimeout(() => setShowCongrats(false), 6000);
    }
  }, [documents, requiredDocs]);

  // Generic upload handler (HEIC conversion + upload to your media endpoint)
  const handleUpload = async (e, key) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadingKey(key);
    let finalFile = file;

    // convert HEIC
    if (file.type === "image/heic" || file.name?.toLowerCase().endsWith(".heic")) {
      try {
        const converted = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.9 });
        finalFile = new File([converted], file.name.replace(/\.heic$/i, ".jpg"), { type: "image/jpeg" });
      } catch (err) {
        console.error("HEIC conversion failed:", err);
        toastError("HEIC conversion failed. Please try a JPG/PNG.");
        setUploadingKey(null);
        return;
      }
    }

    // optional: client-side size or type validations
    const allowed = requiredDocs[key]?.type === "pdf" ? ["application/pdf"] : ["image/jpeg", "image/png", "image/webp", "image/jpg"];
    if (!allowed.includes(finalFile.type) && requiredDocs[key]?.type === "pdf") {
      toastError("Please upload a PDF for this document.");
      setUploadingKey(null);
      return;
    }
    if (!requiredDocs[key]?.type && !allowed.includes(finalFile.type)) {
      // If type not specified, allow images and PDFs
    }

    const form = new FormData();
    form.append("file", finalFile);
    // optionally pass doc key & folder
    form.append("folder", employee?.identification?.aadharNumber || "employee-documents");
    form.append("docKey", key);

    try {
      const uploadRes = await axios.post(`${apiurl}/api/media/employeeFileUpload`, form, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 120000,
      });

      if (uploadRes?.data?.success) {
        const fileUrl = uploadRes.data.fileUrl || uploadRes.data.link || uploadRes.data.path;
        // update local documents state
        setDocuments((prev) => ({
          ...prev,
          [key]: { uploaded: true, link: fileUrl, verificationStatus: "pending" },
        }));
        toastSuccess(`${requiredDocs[key].label} uploaded`);
      } else {
        console.error("Upload response:", uploadRes.data);
        toastError("Upload failed. Try again.");
      }
    } catch (err) {
      console.error("Upload error:", err);
      toastError("Upload failed. Check network or file size.");
    } finally {
      setUploadingKey(null);
    }
  };

  // Submit final documents (update employee by token)
  const handleSubmit = async () => {
    try {
      const payload = { documents };
      const res = await axios.post(`${apiurl}/api/employee/updateEmployeeDetailsByToken/${employeeToken}`, payload);

      if (res.data?.success) {
        toastSuccess("Documents submitted. Thank you!");
        navigate(`/employees/thankyou/${employeeToken}`);
      } else {
        toastError(res.data?.message || "Submit failed");
      }
    } catch (err) {
      console.error("Submit error:", err);
      toastError("Submit failed. Try again.");
    }
  };

  // small toast helpers
  const toastSuccess = (msg) => toast.success(msg || "Done");
  const toastError = (msg) => toast.error(msg || "Error");

  // UI helpers
  const missingKeys = useMemo(() => {
    return Object.keys(requiredDocs).filter((k) => !(documents[k]?.uploaded && documents[k]?.link));
  }, [requiredDocs, documents]);

  const uploadedCount = useMemo(() => {
    return Object.keys(requiredDocs).filter((k) => documents[k]?.uploaded && documents[k]?.link).length;
  }, [requiredDocs, documents]);

  // Early screens for token states
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-gray-600">Verifying link...</div>
      </div>
    );
  }

  if (tokenState === "expired") {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-red-50 text-red-700 p-6">
        <XCircle className="w-20 h-20" />
        <h2 className="text-2xl font-bold mt-4">Link Expired</h2>
        <p className="mt-2 text-center">Contact HR to request a new upload link.</p>
      </div>
    );
  }

  if (tokenState === "used") {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-green-50 text-green-700 p-6">
        <CheckCircle className="w-20 h-20" />
        <h2 className="text-2xl font-bold mt-4">Already Submitted</h2>
        <p className="mt-2 text-center">Your documents are already submitted. Thank you.</p>
      </div>
    );
  }

  // MAIN UI
  return (
    <>
      {/* <Toaster position="top-right" /> */}
      <div className="max-w-4xl mx-auto p-6">
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="mb-6"
        >
          <div className="flex items-center justify-between flex-col sm:flex-row">
            <div>
              <h1 className="text-2xl font-bold">Complete Your Profile</h1>
              <p className="text-sm text-gray-500 mt-1">
                Upload required documents to reach <strong>100% profile completion</strong>.
              </p>
            </div>

            <div className="flex items-center gap-4">
              <div className="text-sm text-gray-600 text-right">
                <div>Completed</div>
                <div className="text-2xl font-bold">{completionPercent}%</div>
                <div className="text-xs text-gray-400">({uploadedCount}/{Object.keys(requiredDocs).length})</div>
              </div>
            </div>
          </div>

          {/* Progress bar */}
          <div className="mt-4">
            <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
              <div
                className="h-4 bg-gradient-to-r from-emerald-500 to-blue-600 transition-all"
                style={{ width: `${completionPercent}%` }}
              />
            </div>
          </div>
        </motion.div>

        {/* Employee top card */}
        <motion.div
          initial={{ opacity: 0, x: -8 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white p-4 rounded-2xl shadow mb-6 border"
        >
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-pink-500 to-indigo-500 flex items-center justify-center text-white text-xl font-bold">
              {employee?.personalDetails?.firstName?.[0]?.toUpperCase() || "U"}
            </div>
            <div>
              <div className="font-semibold text-lg">
                {employee?.personalDetails?.firstName} {employee?.personalDetails?.lastName}
              </div>
              <div className="text-sm text-gray-500">{employee?.personalDetails?.email}</div>
              <div className="text-xs text-gray-400 mt-1">
                ID: {employee?.employeeId} • {employee?.designation || "—"}
              </div>
            </div>
            <div className="ml-auto text-right text-xs text-gray-500">
              <div>Manager: {employee?.reportingManagerName || "—"}</div>
              <div>Joined: {employee?.employeeJoiningDate ? new Date(employee.employeeJoiningDate).toLocaleDateString() : "—"}</div>
            </div>
          </div>
        </motion.div>

        {/* Document stepper + cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left: Stepper */}
          <div className="lg:col-span-1 bg-white p-4 rounded-xl shadow border">
            <h3 className="font-semibold mb-3">Progress Steps</h3>
            <div className="space-y-3">
              {Object.keys(requiredDocs).map((key, idx) => {
                const doc = requiredDocs[key];
                const uploaded = !!(documents[key]?.uploaded && documents[key]?.link);
                return (
                  <motion.div
                    key={key}
                    initial={{ opacity: 0, y: 6 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.05 }}
                    className="flex items-center gap-3"
                  >
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${uploaded ? "bg-green-50 border border-green-100" : "bg-gray-50 border border-gray-100"}`}>
                      {uploaded ? <CheckCircle className="text-green-600 w-5 h-5" /> : <div className="text-xs text-gray-400">{idx+1}</div>}
                    </div>
                    <div>
                      <div className="font-medium">{doc.label}</div>
                      <div className="text-xs text-gray-400">{uploaded ? "Uploaded" : "Pending"}</div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>

          {/* Center: Cards (upload or preview) */}
          <div className="lg:col-span-2 space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {Object.entries(requiredDocs).map(([key, doc], idx) => {
                const uploaded = !!(documents[key]?.uploaded && documents[key]?.link);
                return (
                  <motion.div
                    key={key}
                    initial={{ opacity: 0, scale: 0.98 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: idx * 0.03 }}
                    className={`bg-white rounded-xl p-4 border shadow-sm flex flex-col justify-between ${uploaded ? "ring-2 ring-green-100" : "hover:shadow-md"}`}
                  >
                    <div className="flex items-start gap-3">
                      <div className="w-12 h-12 rounded-lg bg-gray-50 flex items-center justify-center text-xl text-gray-600">
                        <FileText className="w-5 h-5" />
                      </div>

                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <div className="font-semibold">{doc.label}</div>
                          {uploaded && <div className="ml-2 inline-flex items-center text-sm text-green-600"><CheckCircle className="w-4 h-4" /> Uploaded</div>}
                        </div>
                        <div className="text-xs text-gray-400 mt-1">{doc.type === "pdf" ? "PDF" : "Image (JPG/PNG)"}</div>
                      </div>
                    </div>

                    {/* preview / upload actions */}
                    <div className="mt-4 flex items-center gap-3">
                      {uploaded && documents[key]?.link ? (
                        <>
                          <a href={documents[key].link} target="_blank" rel="noreferrer" className="px-3 py-2 border rounded text-sm text-blue-600">
                            View
                          </a>
                          <label className="px-3 py-2 bg-yellow-50 border rounded text-sm cursor-pointer">
                            Replace
                            <input type="file" accept={doc.type === "pdf" ? "application/pdf" : "image/*"} className="hidden" onChange={(e) => handleUpload(e, key)} />
                          </label>
                          <button className="px-3 py-2 bg-red-50 border rounded text-sm text-red-600" onClick={() => {
                            // remove locally
                            setDocuments((prev) => ({ ...prev, [key]: { uploaded: false, link: null } }));
                            toast("Removed upload");
                          }}>
                            Remove
                          </button>
                        </>
                      ) : (
                        <>
                          <label className="px-3 py-2 bg-blue-600 text-white rounded cursor-pointer text-sm flex items-center gap-2">
                            <Upload className="w-4 h-4" />
                            Upload
                            <input type="file" accept={doc.type === "pdf" ? "application/pdf" : "image/*"} className="hidden" onChange={(e) => handleUpload(e, key)} />
                          </label>

                          {uploadingKey === key && <div className="text-sm text-gray-600">Uploading...</div>}

                          <div className="ml-auto text-xs text-gray-400">
                            {uploaded ? "Done" : "Required"}
                          </div>
                        </>
                      )}
                    </div>
                  </motion.div>
                );
              })}
            </div>

            {/* Almost done / CTA */}
            <div className="bg-white p-4 rounded-xl border shadow-sm flex items-center gap-4 flex-col sm:flex-row">
              <div className="w-24">
                {/* <Player src={completionPercent === 100 ? lottieCelebrate : lottieAlmost} autoplay loop={completionPercent !== 100} style={{ width: 96, height: 96 }} /> */}
              </div>

              <div className="flex-1">
                <div className="font-semibold text-lg">
                  {completionPercent === 100 ? "All set — Profile complete!" : "Almost done!"}
                </div>
                <div className="text-sm text-gray-500 mt-1">
                  {completionPercent === 100 ? "Thanks — your documents are uploaded. Click Submit to finish." : `${uploadedCount} of ${Object.keys(requiredDocs).length} documents uploaded. Upload remaining documents to reach 100%.`}
                </div>
              </div>

              <div className="ml-auto">
                <button
                  onClick={handleSubmit}
                  disabled={completionPercent !== 100}
                  className={`px-4 py-2 rounded-lg text-white font-semibold ${completionPercent === 100 ? "bg-green-600 hover:bg-green-700" : "bg-gray-300 cursor-not-allowed"}`}
                >
                  Submit & Complete Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}